export default __webpack_public_path__ + "static/media/crown.93f73140.svg";